export enum ADDRESS_FORM_CONTROL_NAME {
  LATITUDE = 'latitude',
  LONGITUDE = 'longitude'
}
export enum LABELS {
  CHARACTERS_LEFT = 'Characters left',
  ADD_FIST_NAME = '+ Insert First Name'
}
export enum REPLACE_KEY {
  FIRST_NAME = '[First Name]',
  FIRST_NAME_PASCAL = '[FirstName]'
}
export enum ERROR_MESSAGES {
  NFT_ALREADY_ADDED = "This NFT ID has already been added and can't be used again."
}
